export const getErrorMessage = (error) => {
  switch (error) {
    case 'user_does_not_exist':
      return 'FORGOT_PASSWORD.USER_DOES_NOT_EXISTS';
    default:
      return 'COMMON.DEFAULT_ERROR';
  }
};
